<template>
  <div class="course-study-container ">
    <page-background/>
    <div class="box" :style="isMobile?{width:'100%'}:{}">
      <div class="course-detail-route">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <router-link to="/">
              <a-icon type="home"/>
              首页
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <span>视频详情</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>

      <div class="clear-float">
        <course-play/>
      </div>

      <course-info-tab is-course-play class="course-info-tab"/>
    </div>
  </div>

</template>

<script>
import common from "../../mixin/common";
import CoursePlay from "@views/course/components/CoursePlay";
import {
  DISPATCH_INIT_COURSE_INFO,
  DISPATCH_LAST_STUDY_SECTION,
  DISPATCH_SWITCH_SECTION
} from "@constants/action-type/course-action-type";
import CourseInfoTab from "@views/course/components/CourseInfoTab";
import {createNamespacedHelpers} from "vuex";

const {mapState} = createNamespacedHelpers('course');

export default {
  mixins: [common],
  name: "courseStudy",
  components: {
    CoursePlay,
    CourseInfoTab
  },
  mounted() {
    this.$store.dispatch(DISPATCH_INIT_COURSE_INFO, {courseId: this.$route.params.courseId});
    // 判断是否有sectionId属性
    if (this.$route.query.sectionId) {
      // 切换章节
      this.$store.dispatch(DISPATCH_SWITCH_SECTION, {sectionId: this.$route.query.sectionId});
    } else {
      this.$store.dispatch(DISPATCH_LAST_STUDY_SECTION, {courseId: this.$route.params.courseId});
    }
  },
  computed: {
    ...mapState({
      selectedSection: 'selectedSection',
    }),
  },
  watch: {
    selectedSection() {
      this.$router.push({
        query: {sectionId: this.selectedSection.sectionId || ''}
      })
    }
  }
}
</script>

<style scoped lang="less">
.course-study-container {
  padding-bottom: 40px;
}

// 课程详情页头
.course-detail-route {
  font-size: 16px;
  padding: 10px 0 15px;

}

.course-info-tab {
  margin-top: 20px;
  border-radius: 3px;
}

/deep/ .active-section {
  color: #00CF8C;

  .section-name span:nth-of-type(1) {
    /*color: #00CF8C;*/
    background-color: #00CF8C;
  }
}

/deep/ .ant-breadcrumb-link {
  font-size: 16px;
}

</style>
